
import React, { Component } from "react"
import "./PackSelected.scss"
import _PackData from "../../api/HelpPack.json"
import { mobile } from "../Services/Agent"
import BuyButton from "../Helpers/Buttons/BuyButton"
import { push } from "../Services/Analytics";
class PackSelected extends Component {
    constructor() {
        super();
        this.flash = this.flash.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
        this.state = {
            isActive: false,
            current: 0,
            isClickedExtra: false
        }
    }
    componentDidMount() {
        // push("Care_pack", _PackData[this.state.current].team)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.current != this.state.current) {
            this.setState({
                current: nextProps.current
            })
            push("Care_pack", _PackData[nextProps.current].team)
            this.flash();
        }
    }
    flash() {
        this.setState({
            isActive: false
        })
        window.setTimeout(() => this.setState({
            isActive: true
        }), 50);
    }
    postGames() {
        if (Array.isArray(_PackData[this.props.current].games)) {
            return _PackData[this.props.current].games.map((item, index) =>
                <div key={index} className="postgame">{item.date} נגד <span>{item.vs}</span></div>
            );
        } else {
            return <div className="postgame text">{_PackData[this.props.current].games}</div>
        }
    }
    togglePopup() {
        this.setState({
            isClickedExtra: !this.state.isClickedExtra
        })
        this.flash();
    }
    render() {
        const data = _PackData[this.props.current];
        return (
            <div className={`country-story ${this.state.isActive ? " active" : ""}`}>
                <div className="effect">
                    <div className="story-padding">
                        <div className="team">
                            <div className={`shirt shirt-${this.props.ID}`}></div>
                            <div className="team-details">
                                <div className="name">
                                    {data.team}
                                </div>
                                <div className="separator"></div>
                                <div className="games">
                                    <span>משחקים בבית המוקדם:</span>
                                    {this.postGames()}
                                </div>
                            </div>
                        </div>
                        <div className="desc">
                            <div className="flex-container">
                                <div className="headline">
                                    {data.headline}
                                </div>
                                <div className="teaser">
                                    {data.teaser ? <span>{data.teaser}<br /></span> : ""}
                                    {/* <p>{mobile() ? data.desc.replace(" הנה המתכון:", "") : data.desc} <span className="readmore" onClick={this.togglePopup}>{mobile() ? data.desc2_btn : ""}</span></p> */}
                                    <p><span className="html" dangerouslySetInnerHTML={{ __html: data.desc }}></span> <span className="readmore" onClick={this.togglePopup}>{data.desc2_btn}</span></p>
                                    <BuyButton sectionName="רכיב מדינות" buttonText={`לחץ להזמנה`} onClick={() => window.open(data.purchaseLink, "_blank")} />
                                </div>
                                {/* <div className="extra desktop" dangerouslySetInnerHTML={{ __html: data.desc2 }}></div> */}
                                {data.isAlchohol == true ? <div class="info-msg">*צריכה מופרזת של אלכוהול מסכנת חיים ומזיקה לבריאות</div> : ""}
                            </div>
                        </div>
                        <div className="extrapop" style={{ display: this.state.isClickedExtra ? "flex" : "none" }}>
                            <div className="close" onClick={this.togglePopup}>
                                <i aria-hidden="true" className="fa fa-close"></i>
                            </div>
                            <div className="extra-text" dangerouslySetInnerHTML={{ __html: data.desc2 }}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PackSelected;


// WEBPACK FOOTER //
// ./src/Components/HelpPack/PackSelected.jsx